var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-update"},[_c('h2',[_vm._v(_vm._s(_vm.date ? _vm.date : ''))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.messageHTML)}})])}
var staticRenderFns = []

export { render, staticRenderFns }